import { render, staticRenderFns } from "./ApprovalQueue.vue?vue&type=template&id=6b5944dc&"
import script from "./ApprovalQueue.vue?vue&type=script&lang=js&"
export * from "./ApprovalQueue.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalQueue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports